import "core-js/modules/es.string.trim-start.js";
var en = {
  less: 'less than a minute read',
  default: 'min read'
};
var fr = {
  less: "moins d'une minute de lecture",
  default: 'min de lecture'
};
var es = {
  less: "menos de un minuto leyendo",
  default: 'min de lectura'
};
var cn = {
  less: '小于一分钟',
  default: '分钟'
};
var ja = {
  less: '1分未満の読み取り',
  default: '最小読み取り'
};
var SupportedLanguages;

(function (SupportedLanguages) {
  SupportedLanguages["EN"] = "en";
  SupportedLanguages["FR"] = "fr";
  SupportedLanguages["ES"] = "es";
  SupportedLanguages["CN"] = "cn";
  SupportedLanguages["JA"] = "ja";
})(SupportedLanguages || (SupportedLanguages = {}));

var translations = {
  en: en,
  fr: fr,
  es: es,
  cn: cn,
  ja: ja
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

var hasTranslation = function hasTranslation(language) {
  return translations[language];
};

var parseWords = function parseWords(data) {
  var _a;

  return (_a = data.match(/[\t-\r ,\.0-9A-Z_a-z\xA0\xC0-\u024F\u1680\u1E9E\u2000-\u200A\u2028\u2029\u202F\u205F\u212A\u212B\u3000\uFEFF]+/gi)) !== null && _a !== void 0 ? _a : [];
};

var parseChineseWords = function parseChineseWords(data) {
  var _a;

  return (_a = data.match(/[\u4E00-\u9FA5]/g)) !== null && _a !== void 0 ? _a : [];
};

var parseJapaneseWords = function parseJapaneseWords(data) {
  var _a;

  return (_a = data.match(/[\u3041-\u3096]/g)) !== null && _a !== void 0 ? _a : [];
};

var getNumberOfWords = function getNumberOfWords(data) {
  return parseWords(data).reduce(function (accumulator, word) {
    return accumulator + (!word.trim().length ? 0 : word.trim().split(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+/).length);
  }, 0) + parseChineseWords(data).length + parseJapaneseWords(data).length;
};

var isLessThanAMinute = function isLessThanAMinute(minutes) {
  return minutes < 1 + Number.EPSILON;
};

var getLocale = function getLocale(minutes) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SupportedLanguages.EN;
  return translations[hasTranslation(locale) ? locale : SupportedLanguages.EN][isLessThanAMinute(minutes) ? 'less' : 'default'];
};

var readingTime = function readingTime(data) {
  var wordsPerMinute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SupportedLanguages.EN;
  var words = getNumberOfWords(data !== null && data !== void 0 ? data : '');
  var minutes = +Math.round(words / wordsPerMinute).toFixed(2);
  return {
    minutes: minutes,
    words: words,
    text: "".concat(isLessThanAMinute(minutes) ? '' : minutes, " ").concat(getLocale(minutes, language)).trimLeft()
  };
};

export { readingTime };